export const isHTML = (text?: string) => {
  if (!text) {
    return false;
  }

  // Common HTML patterns
  const htmlPatterns = [
    /<[a-z][^>]*>/i, // HTML tags
    /&[a-z]+;/i,     // HTML entities
    /<br\s*\/?>/i,   // Line breaks
    /<\/[a-z]+>/i    // Closing tags
  ];

  return htmlPatterns.some(pattern => pattern.test(text));
}

export const isMarkdown = (text?: string) => {
  if (!text) {
    return false;
  }

  // Common Markdown patterns
  const markdownPatterns = [
    /(?:^|\n)#{1,6}\s/, // Headers
    /\*\*.*?\*\*/,      // Bold
    /\_\_.*?\_\_/,      // Alternative bold
    /\*.*?\*/,          // Italic
    /\_.*?\_/,          // Alternative italic
    /\[.*?\]\(.*?\)/,   // Links
    /(?:^|\n)\s*[\*\-\+]\s/, // Unordered lists
    /(?:^|\n)\s*\d+\.\s/,    // Ordered lists
    /\`.*?\`/,          // Inline code
    /(?:^|\n)>\s/m      // Blockquotes
  ];

  return markdownPatterns.some(pattern => pattern.test(text));
}
